/* eslint-disable */
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-document-settings-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title' style="padding-left: 10px;">
        {{ 'TITLE.SETTINGS' | translate }}
      </h4>
      <button type='button' class='btn-close' aria-label='Close' (click)='activeModal.close("CLOSE")'>
      </button>
    </div>

    <div class='modal-body'>
      <div class="options">
        <!--        <img src="https://via.placeholder.com/125" class="options-image" alt="Placeholder Image">-->
        <div class="options-body">
          <h5 class="options-title">
            {{ 'TITLE.REINDEX' | translate }}
          </h5>
          <p class="options-description">
            {{'MESSAGE.DOCUMENT_SETTINGS.REINDEX_DESCRIPTION_01' | translate}}
          </p>
          <p class="options-description">
            {{'MESSAGE.DOCUMENT_SETTINGS.REINDEX_DESCRIPTION_02' | translate}}
          </p>
          <p class="options-description">
            {{'MESSAGE.DOCUMENT_SETTINGS.REINDEX_DESCRIPTION_03' | translate}}
          </p>
          <div class="options-btn">
            <button type="button" class="btn btn-primary" (click)='activeModal.close("REINDEX")'>
              {{ 'BUTTON.RUN' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="options">
        <!--        <img src="https://via.placeholder.com/125" class="options-image" alt="Placeholder Image">-->
        <div class="options-body">
          <h5 class="options-title">
            {{ 'TITLE.RESETCOL' | translate }}
          </h5>
          <p class="options-description">
            {{'MESSAGE.DOCUMENT_SETTINGS.RESETCOL_DESCRIPTION_01' | translate}}
          </p>
          <p class="options-description">
            {{'MESSAGE.DOCUMENT_SETTINGS.RESETCOL_DESCRIPTION_02' | translate}}
          </p>
          <div class="options-btn">
            <button type="button" class="btn btn-primary" (click)='activeModal.close("RESETCOL")'>
              {{ 'BUTTON.RUN' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class='modal-footer'>-->
    <!--      <button type='button' class='btn btn-outline-secondary btn-sm'-->
    <!--              (click)='activeModal.close(false); $event.stopPropagation()'>-->
    <!--        {{ customConfirmBtnLabel ? (customConfirmBtnLabel | async) : ('BUTTON.CLOSE' | translate) }}-->
    <!--      </button>-->
    <!--    </div>-->
  `,
  styles: [`
    .options {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      padding: 0;
      margin: 0 0 30px 0;
    }

    .options .options-image {
      width: 125px;
      display: inline-flex;
    }

    .options .options-body {
      width: 100%;
      display: flex;
      flex-direction: column;
      padding-left: 10px;
      /*height: 125px;*/
    }

    .options .options-body .options-title {

    }

    .options .options-body .options-description {
      /*margin-bottom: 3px;*/
      padding-left: 20px;
    }

    .options .options-body .options-btn {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      margin-top: 10px;
      padding-left: 20px;
    }

    .options .options-body .options-btn button {
      border-radius: 0;
    }
  `]
})
export class DocumentSettingsDialogComponent {
  constructor(public activeModal: NgbActiveModal, private translateService: TranslateService) {
  }
}

